/**
 * The portal's paths, in one place so the route table, the frame and any link agree. Home is the
 * bare origin, which is also where Checkout's rail opens the portal (`@nexus/nexus-shell`'s
 * `railItems`). Connections (NEX2-229) and Settings (NEX2-230) add theirs.
 */
export const PORTAL_PATHS = {
  home: "/",
} as const;
